<div class="page">
  <custom-onboarding
    (onClickLastNextButton)="onboardingFinished()"
    (onClickFirstPreviousButton)="returnToThePreviousPage()"
  >
    <cdk-step>
      <app-is-company class="step" [isCompanyControl]="isCompanyControl">
      </app-is-company>
    </cdk-step>

    <cdk-step *ngIf="isCompanyControl.valueChanges | async">
      <app-is-client
        class="step"
        [isClientControl]="isClientControl"
        [clientCodeControl]="clientCodeControl"
      >
      </app-is-client>
    </cdk-step>

    <cdk-step>
      <app-data
        class="step"
        [isClient]="isClientControl.value"
        [dataForm]="dataForm"
      >
      </app-data>
    </cdk-step>

    <cdk-step>
      <app-user-password
        class="step"
        [userPasswordForm]="userPasswordForm"
        [isLoading]="isSignUpLoading$ | async"
      >
      </app-user-password>
    </cdk-step>

    <cdk-step *ngIf="!isClientControl.value">
      <app-postal-code
        class="step"
        [postalCodeControl]="postalCodeControl"
        [isLoading]="isSignUpLoading$ | async"
      >
      </app-postal-code>
    </cdk-step>
  </custom-onboarding>
</div>
